import type { GiftPassPurchaser } from '../../api/gift-passes';

const SECONDARY = {
  fontSize: 11.5,
  color: 'var(--nb-subtle)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

export function GiftPassPurchaserCell({ purchaser }: { purchaser: GiftPassPurchaser }) {
  return (
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--nb-ink)' }}>
        {purchaser.name ?? purchaser.email}
      </div>
      {purchaser.name && <div style={SECONDARY}>{purchaser.email}</div>}
    </div>
  );
}
